import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AllObjectsDemo } from './pages/all-objects/all-objects.component';
import { CameraTools } from './pages/camera-tools/camera-tools.component';
import { ClippingPlanesDemo } from './pages/clipping-planes/clipping-planes.component';
import { CompositeMaterialsDemo } from './pages/composite-materials/composite-materials.component';
import { CustomShadersDemo } from './pages/custom-shaders/custom-shaders.component';
import { DefaultPageComponent } from './pages/default-page/default-page.component';
import { DemoWith500000ItemsComponent } from './pages/demo-with-500000-items/demo-with-500000-items.component';
import { IndexedMeshObject } from './pages/indexed-mesh-object/indexed-mesh-object.component';
import { LayerPositionDemo } from './pages/layer-position/layer-position.component';
import { LayersDemo } from './pages/layers/layers.component';
import { LightsDemo } from './pages/lights/lights.component';
import { LinesDemo } from './pages/lines/lines.component';
import { PointsDemo } from './pages/points/points.component';
import { RaycastDemo } from './pages/raycast/raycast.component';
import { HypersceneArtifactsDemo } from './pages/hyperscene-artifacts/hyperscene-artifacts.component';
import { HypersceneNewDemo } from './pages/hyperscene-new/hyperscene-new.component';
import { HypersceneViewerDemo } from './pages/hyperscene-viewer/hyperscene-viewer.component';
import { SdkViewerDemo } from './pages/sdk-viewer/sdk-viewer.component';
import type { ShowcaseModule } from './pages/showcase/showcase.module';
import { IfcMergeToolsComponent } from './pages/merge-tools/merge-tools.component';
import { SpritesDemo } from './pages/sprites/sprites.component';
import { StandardGeometricObjects } from './pages/standard-geometric-objects/standard-geometric-objects.component';
import { TexturedGeometricObjects } from './pages/textured-geometric-objects/textured-geometric-objects.component';
import { UiToolsDemo } from './pages/ui-tools/ui-tools.component';
import { UserActionsComponent } from './pages/user-actions/user-actions.component';
import { UniqueObjectsDemo } from './pages/unique-objects/unique-objects.component';
import { ViewerHelpComponent } from './pages/viewer-help/viewer-help.component';
import { VIEWER_HELP_PATH } from './app-route-layout';

const routes: Routes = [
  {
    path: '',
    component: DefaultPageComponent,
  },
  {
    path: '500 000 items',
    component: DemoWith500000ItemsComponent,
  },
  {
    path: 'user-actions',
    component: UserActionsComponent,
  },
  {
    path: 'camera-tools',
    component: CameraTools,
  },
  {
    path: 'indexed-mesh-object',
    component: IndexedMeshObject,
  },
  {
    path: 'standard-geometric-objects',
    component: StandardGeometricObjects,
  },
  {
    path: 'lights',
    component: LightsDemo,
  },
  {
    path: 'textured-geometric-objects',
    component: TexturedGeometricObjects,
  },
  {
    path: 'lines',
    component: LinesDemo,
  },
  {
    path: 'points',
    component: PointsDemo,
  },
  {
    path: 'all-objects',
    component: AllObjectsDemo,
  },
  {
    path: 'layers',
    component: LayersDemo,
  },
  {
    path: 'sprite-objects',
    component: SpritesDemo,
  },
  {
    path: 'raycast',
    component: RaycastDemo,
  },
  {
    path: 'custom-shaders',
    component: CustomShadersDemo,
  },
  {
    path: 'ui-tools',
    component: UiToolsDemo,
  },
  {
    path: 'tools',
    component: IfcMergeToolsComponent,
  },
  {
    path: 'clipping-planes',
    component: ClippingPlanesDemo,
  },
  {
    path: 'layer-position',
    component: LayerPositionDemo,
  },
  {
    path: 'hyperscene',
    component: HypersceneNewDemo,
  },
  {
    path: 'hyperscene-new',
    redirectTo: 'hyperscene',
    pathMatch: 'full',
  },
  {
    path: 'artifacts',
    component: HypersceneArtifactsDemo,
  },
  {
    path: 'showcase',
    loadChildren: () =>
      import('./pages/showcase/showcase.module').then(
        (module: { ShowcaseModule: typeof ShowcaseModule }) => module.ShowcaseModule
      ),
  },
  {
    path: 'viewer/embed',
    component: HypersceneViewerDemo,
    data: { sceneOnly: true, debug: true },
  },
  {
    path: 'viewer/sdk',
    component: SdkViewerDemo,
  },
  {
    path: 'viewer',
    component: HypersceneViewerDemo,
  },
  {
    path: VIEWER_HELP_PATH,
    component: ViewerHelpComponent,
  },
  {
    path: 'hyperscene-advanced',
    redirectTo: 'viewer',
    pathMatch: 'full',
  },
  {
    path: 'composite-materials',
    component: CompositeMaterialsDemo,
  },
  {
    path: 'unique-objects',
    component: UniqueObjectsDemo,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
